

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {KhachHang} from "@/models/khachHang";
import {KhachHangUpdate} from "@/models/khachHangUpdate";
import {NhapHangHoaCreate} from "@/models/nhapHangHoaCreate";
import {NhapHangHoaUpdate} from "@/models/nhapHangHoaUpdate";
import {NhapHangHoaDetail} from "@/models/nhapHangHoaDetail";
import router from "@/router";

export default {

  setup(){
    const router = useRouter();
    const nhapHangHoaCreate = ref({} as NhapHangHoaCreate);
    const nhapHangHoaUpdate = ref({} as NhapHangHoaUpdate);
    const listNhapHangHoaDetail = ref([] as NhapHangHoaDetail[]);
    const toast = useToast();
    const date = ref();
    const dateMuaHang =  ref();
    const dateMuaHangUpdate =  ref();
    const store = useStore();
    const error = ref(null);
    const showUpdate = ref(false);
    if (!!!store.state.token) {
      router.push({ name: "home" });
    }
    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }
    nhapHangHoaCreate.value.chietKhau = 0;

    const validHangHoa= computed(()=>  nhapHangHoaCreate.value.tenHangHoa && nhapHangHoaCreate.value.giaBan  && nhapHangHoaCreate.value.chietKhau >= 0 && nhapHangHoaCreate.value.giaNhap && nhapHangHoaCreate.value.soLuong);
    const validHangHoaUpdate = computed(()=>  nhapHangHoaUpdate.value.tenHangHoa && nhapHangHoaUpdate.value.giaBan  && nhapHangHoaUpdate.value.chietKhau  >= 0 && nhapHangHoaUpdate.value.giaNhap && nhapHangHoaUpdate.value.soLuong&& nhapHangHoaUpdate.value.thoiGianMuaHang );


    const getListHangHoa = () => {
      if ((date.value[0] != null) && (date.value[1] != null)) {
        AuthRepository.getListNhapHangHoa(date.value[0] / 1000, date.value[1] / 1000)
            .then((response) => {
              listNhapHangHoaDetail.value = response.data;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }


      // else{
      //   AuthRepository.getListNhapHangHoa(0, 0)
      //       .then((response) => {
      //         listNhapHangHoaDetail.value = response.data;
      //       })
      //       .catch(err => {
      //         toast.add({
      //           severity: 'error',
      //           summary: 'Lỗi',
      //           detail: err.response.data,
      //           life: 2000
      //         });
      //       });
      // }
    }
      // getListHangHoa();

    const clearCalendar = () => {
      console.log("@@@@@@@@@################ clearDate");
      date.value = new Date();
      listNhapHangHoaDetail.value = [];
    }

    const createHangHoa = () => {
      if(dateMuaHang.value != null) {
        nhapHangHoaCreate.value.thoiGianMuaHang = dateMuaHang.value;
      }
      console.log("######################### createHangHoa");
      console.log("######################### createHangHoa khachHangCreate: " + JSON.stringify(nhapHangHoaCreate.value));
        AuthRepository.createNhapHangHoa(nhapHangHoaCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm hàng hóa thành công',
              life: 2000
            });
            getListHangHoa();
            const temp = ref({} as NhapHangHoaCreate);
            nhapHangHoaCreate.value = temp.value;
            nhapHangHoaCreate.value.chietKhau = 0;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const selectHangHoa = (id) => {
      listNhapHangHoaDetail.value.forEach(x =>{
        if(x.id == id){
          nhapHangHoaUpdate.value.tenHangHoa = x.tenHangHoa;
          nhapHangHoaUpdate.value.giaBan = x.giaBan;
          nhapHangHoaUpdate.value.chietKhau = x.chietKhau;
          nhapHangHoaUpdate.value.giaNhap = x.giaNhap;
          nhapHangHoaUpdate.value.soLuong = x.soLuong;
          nhapHangHoaUpdate.value.id = x.id;
          nhapHangHoaUpdate.value.thoiGianMuaHang = x.thoiGianMuaHang;
          showUpdate.value = true;
        }
      })
    }

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "";
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatCurrency = (money) => {
      // Use Intl.NumberFormat to format the number as currency
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0, // Set the number of decimal places you want
      });
      return formatter.format(money);
    };

    const giaNhap = () => {
      if(nhapHangHoaCreate.value.giaBan && nhapHangHoaCreate.value.chietKhau >=0)
      {
        nhapHangHoaCreate.value.giaNhap = nhapHangHoaCreate.value.giaBan - (nhapHangHoaCreate.value.giaBan * nhapHangHoaCreate.value.chietKhau) / 100;
      }
    }

    const tinhTienCreate = () => {
        if(nhapHangHoaCreate.value.giaNhap && nhapHangHoaCreate.value.soLuong) {
          nhapHangHoaCreate.value.tongTien = nhapHangHoaCreate.value.giaNhap* nhapHangHoaCreate.value.soLuong;
        }
    };


    const giaNhapUpdate = () => {
      if(nhapHangHoaUpdate.value.giaBan && nhapHangHoaUpdate.value.chietKhau >=0)
      {
        nhapHangHoaUpdate.value.giaNhap = nhapHangHoaUpdate.value.giaBan - (nhapHangHoaUpdate.value.giaBan * nhapHangHoaUpdate.value.chietKhau) / 100;
      }
    }
    const tinhTienUpdate = () => {
      if(nhapHangHoaUpdate.value.giaNhap && nhapHangHoaUpdate.value.soLuong) {
        nhapHangHoaUpdate.value.tongTien = nhapHangHoaUpdate.value.giaNhap * nhapHangHoaUpdate.value.soLuong;
      }
    };


    const updateHangHoa = () => {
      console.log("######################### updateHangHoa");
      console.log("######################### updateHangHoa khachHangUpdate: " + JSON.stringify(nhapHangHoaUpdate.value));
      if(dateMuaHangUpdate.value != null) {
        nhapHangHoaUpdate.value.thoiGianMuaHang = dateMuaHangUpdate.value;
      }
      AuthRepository.updateNhapHangHoa(nhapHangHoaUpdate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Cập nhật dữ liệu hàng hóa thành công',
              life: 2000
            });
            getListHangHoa();
            showUpdate.value = false;
            const temp = ref({} as NhapHangHoaUpdate);
            nhapHangHoaUpdate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    return {
      error,
      formatDateTime,
      filters,
      clearFilter,
      initFilters,
      formatCurrency,
      tinhTienCreate,
      validHangHoa,
      validHangHoaUpdate,
      date,
      nhapHangHoaCreate,
      nhapHangHoaUpdate,
      listNhapHangHoaDetail,
      showUpdate,
      getListHangHoa,
      createHangHoa,
      selectHangHoa,
      updateHangHoa,
      tinhTienUpdate,
      clearCalendar,
      dateMuaHang,
      dateMuaHangUpdate,
      giaNhap,
      giaNhapUpdate,
      // donVi,
    }
  }
}

